<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />

    <div v-show="newVersion()">
      <h1 class="text-center title">{{ LG("HP_planDeSiteButtonLabel") }}</h1>
      <div class="sitemap-container">
        <b-tabs content-class="sitemap-area-new pl-4" align="center">
          <!-- Loop through tabs -->
          <b-tab :title="tab.name" v-for="(tab, tabIndex) in tabs" :active="index === 0 ? true : false" :key="'tab' + tabIndex">
            <h2 class="mb-4 mt-1">{{ tab.name }}</h2>

            <ul class="link-list" v-if="tab.linkList">
              <!-- Loop through tab link -->
              <li v-for="tabLink in tab.linkList" :key="tabLink.path">
                <a :href="tabLink.path">{{ tabLink.name }}</a>
              </li>
            </ul>
            <!-- Loop through section -->
            <div class="mt-2" v-for="(section, sectionIndex) in tab.sections" :key="'section' + sectionIndex">
              <h3 v-if="section.path">
                <a :href="section.path">{{ removeHtmlCode(section.name) }}</a>
              </h3>
              <h3 v-else>{{ removeHtmlCode(section.name) }}</h3>
              <ul class="link-list" v-if="section.linkList">
                <!-- Loop through section link -->
                <li v-for="link in section.linkList" :key="link.path">
                  <a :href="link.path">{{ link.name }}</a>
                </li>
              </ul>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";

export default {
  components: {
    ProgressBars,
  },
  data() {
    return {
      tabs: [],

      // tabs: [
      //   {
      //     name: "name of tab",
      //     linkList: [
      //       {
      //         name: "displayed name",
      //         ath: "path",
      //       },
      //       // ...
      //     ],
      //     sections: [
      //       {
      //         name: "section name",
      //         linkList: [
      //           {
      //             name: "displayed name",
      //             path: "path",
      //           },
      //           // ...
      //         ],
      //       },
      //     ],
      //   },
      //   // ...
      // ],
    };
  },
  computed: {},
  created() {
    this.populateTabsLinksList();
  },

  methods: {
    // populate this.tabs
    populateTabsLinksList() {
      this.tabs.push(
        {
          name: "Général",
          // linkList: [{ name: "Carte", path: this.getRoutePath("area") }],
          sections: [
            {
              name: "Carte et bloc-notes",
              linkList: [
                { name: "Carte", path: this.getRoutePath("area") },
                { name: "Bloc-notes", path: this.getRoutePath("Blocnote") },
              ],
            },
            {
              name: "Fonctionnalités",
              linkList: [
                // { name: "Accueil", path: this.getRoutePath("home") },
                { name: "S'inscrire", path: this.getRoutePath("register") },
                { name: "Réinitialiser le profil", path: this.getRoutePath("reset") },
                // { name: "Plan de site", path: this.getRoutePath("Sitemap") },
              ],
            },
            {
              name: "Fiches pour animer une communauté d’apprentissage professionnelle (CAP)",
              path: this.getRoutePath("AnimationSheetHomePage"),
              linkList: [
                { name: "Créer des liens pour le bien-être et l’apprentissage de l’enfant", path: this.getRoutePath("AnimationSheet1") },
                { name: "Partons explorer avec les enfants...", path: this.getRoutePath("AnimationSheet2") },
                { name: "L’environnement pour nous appuyer", path: this.getRoutePath("AnimationSheet3") },
                { name: "Familles engagées, enfants épanouies et épanouis!", path: this.getRoutePath("AnimationSheet4") },
              ],
            },
            {
              name: "Ressources pour aller plus loin",
              path: this.getRoutePath("pourAllerPlusLoinHomePage"),
              linkList: [
                { name: "Les relations authentiques", path: this.getRoutePath("pourAllerPlusLoin1") },
                { name: "L’apprentissage par l’exploration, le jeu et l’enquête.", path: this.getRoutePath("pourAllerPlusLoin2") },
                { name: "L’environnement comme troisième éducateur", path: this.getRoutePath("pourAllerPlusLoin3") },
                { name: "L’engagement familial", path: this.getRoutePath("pourAllerPlusLoin4") },
              ],
            },
          ],
        },
        { name: this.LG("SA_nameAreaSection1"), linkList: [], sections: [] },
        { name: this.LG("SA_nameAreaSection2"), linkList: [], sections: [] },
        { name: this.LG("SA_nameAreaSection3"), linkList: [], sections: [] },
        { name: this.LG("SA_nameAreaSection4"), linkList: [], sections: [] }
      );

      this.areaSituationsMatch.forEach((area) => {
        this.tabs[area.index + 1].sections.push({ name: "Choix de mise en sitation", path: this.getRoutePath("situations", area.index) });

        area.situations.forEach((situation) => {
          this.tabs[area.index + 1].sections.push({
            name: this.LG(`SS_labelSituation${situation + 1}`),
            path: this.getRoutePath("video", area.index, situation),
            linkList: [
              // { name: "Video", path: this.getRoutePath("video", area.index, situation) },
              { name: "Mise en situation", path: this.getRoutePath("tutorial", area.index, situation) }, //la mise en situation
              //{ name: 'Jouer', path: this.getRoutePath("play", area.index, situation) },
              { name: "Résumé des indices", path: this.getRoutePath("resume", area.index, situation) }, // Résumé des indices
              { name: "Intervention", path: this.getRoutePath("intervention", area.index, situation) },
              { name: "Conclusion", path: this.getRoutePath("conclusion", area.index, situation) },
              { name: "Jeu-questionnaire", path: `/jeu-questionnaire/situation${situation + 1}/jeu.html` },
              { name: "Sommaire", path: this.getRoutePath("quizrecap", area.index, situation) },
            ],
          });
        });
      });
    },

    getRoutePath(routeName, areaIndex = null, situationIndex = null) {
      // get path
      let routePath = this.$router.options.routes.find((x) => x.name == routeName).path;

      // change param :areaName to the real name
      if (areaIndex != null) {
        routePath = routePath.replace(":areaName", this.getAreaNameFromAreaIndex(areaIndex));
      }

      // change param :situationName to the real name
      if (situationIndex != null) {
        routePath = routePath.replace(":situationName", this.getSituationNameFromSituationIndex(situationIndex));
      }

      return routePath;
    },
    removeHtmlCode(string) {
      let regex = /(<([^>]+)>)/gi;
      return string.replace(regex, "");
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 28px !important;
}
h3 {
  font-size: 18px !important;
  margin-top: 35px;
}
.sitemap-container {
  width: 95%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

::v-deep .sitemap-area-new,
::v-deep .nav.nav-tabs {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  font-size: 17px;
  color: black;
  padding: 25px 15px;
  margin-bottom: 20px;
}

a,
a:link,
a:visited {
  color: #1f2d4c !important;
  font-size: 1.1rem;
}
a:hover,
a:focus {
  text-decoration: underline !important;
}
h2 a,
h2 a:link,
h2 a:visited {
  color: #000 !important;
}
ul.link-list {
  list-style: none; /* Remove default bullets */
}
ul.link-list li::before {
  content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #5aa9af; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: -1em; /* Also needed for space (tweak if needed) */
}
@media reader, speech, aural {
  ul.link-list li::before {
    display: none !important;
    visibility: hidden !important;
  }
}

h1.title {
  text-align: center;
  margin-top: 5px;
  margin-bottom: 25px;
  font-family: "Poppins";
  color: #333;
}

::v-deep .nav-tabs .nav-link {
  font-size: 1.35rem !important;
  color: #000 !important;
  font-weight: bold;
}
::v-deep .nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  text-decoration: underline !important;
  border-color: transparent !important;
}
</style>
